import React from "react";
import "../assets/css/about.scss";
import "../App.css";

const About = () => {
  return (
    <section id="about">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Who I Am</span>
          <h1 className="section-title">About Me</h1>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p>
              I'm a full-stack web developer with a passion for building
              experiences that are as functional as they are visually
              intentional. I go by the alias{" "}
              <strong>EnigmaTech</strong> — a name that reflects how I work:
              methodical, precise, and quietly capable.
            </p>
            <p>
              My professional background spans fintech products, enterprise
              dashboards, and cross-platform mobile applications. I specialise
              in JavaScript and TypeScript ecosystems — React, Angular and
              Ionic on the front end, Node.js and Firebase on the back — with
              a consistent focus on clean architecture, performance, and code
              that scales. Since 2025 I have been the sole engineer on OK
              Let's Go!, a rideshare platform with rider and driver apps, a
              Firebase backend and a Next.js admin dashboard.
            </p>
            <p>
              I work best at the intersection of design intuition and
              engineering rigour. Whether collaborating within a team or
              driving a project independently, I hold the same standard:
              understand the problem deeply, build the right solution, and
              deliver work I can stand behind.
            </p>
          </div>

          <div className="about-card glass-panel">
            <span className="code-title">
              <i className="fa fa-code"></i> enigmatech.js
            </span>
            <pre className="code-block" aria-hidden="true">
              <code>
                <span className="t-kw">const </span>
                <span className="t-name">enigmatech</span>
                <span className="t-punct"> = {"{"}</span>
                {"\n"}
                {"  "}
                <span className="t-key">alias</span>
                <span className="t-punct">:    </span>
                <span className="t-str">"EnigmaTech"</span>
                <span className="t-punct">,</span>
                {"\n"}
                {"  "}
                <span className="t-key">role</span>
                <span className="t-punct">:     </span>
                <span className="t-str">"Full-Stack Web & Mobile Dev"</span>
                <span className="t-punct">,</span>
                {"\n"}
                {"  "}
                <span className="t-key">focus</span>
                <span className="t-punct">:    [</span>
                <span className="t-str">"Frontend"</span>
                <span className="t-punct">, </span>
                <span className="t-str">"Backend"</span>
                <span className="t-punct">, </span>
                <span className="t-str">"Mobile"</span>
                <span className="t-punct">],</span>
                {"\n"}
                {"  "}
                <span className="t-key">stack</span>
                <span className="t-punct">:    [</span>
                <span className="t-str">"React"</span>
                <span className="t-punct">, </span>
                <span className="t-str">"Ionic"</span>
                <span className="t-punct">, </span>
                <span className="t-str">"Firebase"</span>
                <span className="t-punct">, </span>
                <span className="t-str">"Angular"</span>
                <span className="t-punct">],</span>
                {"\n"}
                {"  "}
                <span className="t-key">status</span>
                <span className="t-punct">:   </span>
                <span className="t-available">"Available for work"</span>
                <span className="t-punct">,</span>
                {"\n"}
                <span className="t-punct">{"}"}</span>
                <span className="t-punct">;</span>
              </code>
            </pre>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
